import { IEntity } from "@interfaces/entity";
import { SubscriptionType } from "./subscriptionType";

export class Subscription implements IEntity {
  id: number;

  subscriptionTypeId: number;
  subscriptionType: SubscriptionType;

  startDate: Date;
  endDate: Date;

  entityName = "Subscription";

  constructor(formValue?: Partial<Subscription>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<Subscription>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }
}
